module.exports = __webpack_public_path__ + "media/images/wifi gratuit-2bdeaeb3fcb1642e44842f5b61b6be20.svg";